import React, {useState} from 'react';
import TableRow          from '@mui/material/TableRow';
import Skeleton          from '@mui/material/Skeleton';
import TableCell         from '@mui/material/TableCell';
import {useTranslation}  from 'react-i18next';
import Button            from '../../../../../../inputs/Button';
import EditIcon          from '@mui/icons-material/Edit';
import Grid              from '@mui/material/Grid';
import {DeleteForever}   from '@mui/icons-material';
import DeleteDialog      from '../DeleteDialog';
import EditDialog        from '../EditDialog';


const Row = ({value, loading}) => {
	const displayFee = (!loading && value);
	const {t} = useTranslation();
	const [showDelete, setShowDelete] = useState(false);
	const [showEdit, setShowEdit] = useState(false);


	return (
        <TableRow>
            <TableCell>
				{!displayFee && <Skeleton/>}
				{displayFee && <span>{value?.Country?.Name ?? t('all')}</span>}
			</TableCell>
            <TableCell>
				{!displayFee && <Skeleton/>}
				{displayFee && <span>{(!value.Province || !value.Province.trim()) ? t('all') : value.Province}</span>}
			</TableCell>
            <TableCell align="right">
				{!displayFee && <Skeleton/>}
				{(displayFee) && <Grid container spacing={3} justifyContent="space-between">
					<Grid item>
						<Button
							variant="outlined"
							color="secondary"
							onClick={() => setShowDelete(true)}
							startIcon={<DeleteForever/>}
						>
							{t('delete_btn')}
						</Button>
					</Grid>

					<Grid item>
						<Button
							variant="contained"
							color="primary"
							onClick={() => setShowEdit(true)}
							startIcon={<EditIcon/>}
						>
							{t('edit_btn')}
						</Button>
					</Grid>
				</Grid>}
			</TableCell>
            {showDelete && <DeleteDialog setOpen={setShowDelete} open={showDelete} value={value}/>}
            {showEdit && <EditDialog setOpen={setShowEdit} open={showEdit} value={value}/>}
        </TableRow>
    );
};


export default Row;